import { render, staticRenderFns } from "./zjs.vue?vue&type=template&id=21795f68&scoped=true&"
var script = {}
import style0 from "./zjs.vue?vue&type=style&index=0&id=21795f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21795f68",
  null
  
)

export default component.exports